import { environment } from '../../../environments/environment';

export class BaseConfig {

  public static getBaseUrlApi(): string {

    let uri = 'http://localhost:65122/';

    if (environment.ambiente === 'prod') {
      uri = 'https://www.npb.sefaz.ba.gov.br/webservices/nbpa/portal/';
    } else if (environment.ambiente === 'hml') {
      uri = 'https://www.hnpb.sefaz.ba.gov.br/webservices/nbpa/portal/';
    } else if (environment.ambiente === 'devSefaz') {
      uri = 'https://www.dnpb.sefaz.ba.gov.br/webservices/nbpa/portal/';
    } else if (environment.ambiente === 'testeSefaz') {
      uri = 'https://tnpb.sefaz.ba.gov.br/webservices/NBPA/portal/';
    } else if (environment.ambiente === 'hmli') {
      uri = 'http://localhost/nbp/api/';
    }
    return uri;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/base-config.ts